import axios from "axios";
import { API_URL } from '../Constants';

class ClientUserService {
    loginUser(credentials) {
        return axios.post(`${API_URL}console/loginUser/`, credentials);
    };

    autoLoginUser(userId, token) {
        return axios.post(`${API_URL}console/autoLoginUser/`, { accessToken: token, userId: userId });
    };

    checkSetPasswordToken(sessionId, userId) {
        return axios.get(`${API_URL}console/checkSetPasswordToken/${sessionId}/${userId}`);
    };

    setNewPassword(sessionId, userId, newPassword) {
        return axios.post(`${API_URL}console/setNewPassword/${sessionId}/${userId}`, { newPassword: newPassword });
    };

    createUser(token, tenant, userData) {
        return axios.post(`${API_URL}console/tenant-user/${tenant}`, userData, { headers: { Authorization: `Bearer ${token}` } });
    };

    getTenantUsers(tenantID, token) {
        return axios.get(`${API_URL}console/tenant-user/${tenantID}`, { headers: { Authorization: `Bearer ${token}` } });
    };

    checkUserEmail(accessToken, email) {
        return axios.get(`${API_URL}console/check-tenant-user/${email}`, { headers: { Authorization: `Bearer ${accessToken}` } });
    };

    updateUserPermissions(token, tenant, permissions) {
        return axios.put(`${API_URL}console/tenant-user-permissions/${tenant}`, permissions, { headers: { Authorization: `Bearer ${token}` } });
    };

    removeUser(token, tenant, userID) {
        return axios.delete(`${API_URL}console/tenant-user/${tenant}/${userID}`, { headers: { Authorization: `Bearer ${token}` } });
    };
};

ClientUserService = new ClientUserService();
export default ClientUserService;